import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import theme from '../../theme-config';
import { BulletPoint, Separator, Text } from 'trpc-react-native-ui';

class TwoColumnsList extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View>
        <View style={styles.container}>
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{this.props.title}</Text>
          </View>
          <View style={styles.textContainer}>
            {this.props.text.split('\n').map(text => (
              <BulletPoint textStyle={styles.text} text={text} />
            ))}
          </View>
        </View>
        <Separator />
      </View>
    );
  }
}

type Props = {
  title: string,
  text: string,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    title: {
      color: theme.internationalRoamingTitleColor,
      fontSize: 16,
      fontWeight: 'bold',
    },
    text: {
      fontSize: 13,
      paddingRight: 5,
    },
    textContainer: {
      padding: 17,
      flex: 2.5,
    },
    titleContainer: {
      padding: 17,
      flex: 1,
    },
  });

export default TwoColumnsList;
